import React, {createContext, useState, useContext} from "react";

interface SideBarState {
	component?: React.ReactNode;
}

interface SideBarContextProps {
	sidebar: SideBarState;
	resetSideBar: () => void;
}

const SidebarContext = createContext<SideBarContextProps | undefined>(undefined);

export const SideBarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const defaultMenu: SideBarState = {
		component: undefined,
	};
	const [sidebar, setSidebar] = useState<SideBarState>(defaultMenu);

	const resetSideBar = () => setSidebar(defaultMenu);

	return (
		<SidebarContext.Provider value={{ sidebar, resetSideBar }}>
			{children}
		</SidebarContext.Provider>
	);
};

export const useSideBar = (): SideBarContextProps => {
	const context = useContext(SidebarContext);
	if (!context) {
		throw new Error("useSidebar must be used within a SideBarProvider");
	}
	return context;
};